const CAROUSEL_ITEMS = [
  {
    title: '范马刃牙 — 父子决战',
    desc: '刃牙与父亲范马勇次郎的终极对决终于到来。地表最强生物VS不断进化的格斗天才，这场跨越血脉的巅峰之战，将格斗漫画的张力推向了极致。',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20epic%20manga%20style%20showdown%20between%20two%20powerful%20fighters%20father%20and%20son%2C%20dramatic%20silhouettes%20against%20burning%20sunset%20sky%2C%20warm%20crimson%20and%20gold%20tones%2C%20Japanese%20comic%20art%2C%20cinematic%20wide%20composition&width=800&height=600&seq=baki-carousel-01&orientation=landscape',
    tag: '人气最高',
  },
  {
    title: '刃牙道 — 宫本武藏复活',
    desc: '传奇剑豪宫本武藏在现代世界复活。古代最强遇上现代最强，刃牙将如何应对这位跨越时空的绝世强者？一场古今最强之战震撼上演。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20samurai%20warrior%20clashing%20with%20modern%20fighter%20in%20manga%20art%20style%2C%20ancient%20versus%20modern%20theme%2C%20warm%20golden%20and%20dark%20ink%20tones%2C%20Japanese%20comic%20aesthetic%2C%20dynamic%20action%20composition&width=800&height=600&seq=baki-carousel-02&orientation=landscape',
    tag: '必读篇章',
  },
  {
    title: '刃牙II — 死囚篇',
    desc: '五名世界顶级死刑犯为了寻求败北来到东京。刃牙与伙伴们迎战这群来自各地的疯狂格斗者，每一场战斗都是生与死的极致较量。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20scene%20of%20intense%20underground%20prison%20fighting%2C%20multiple%20dangerous%20fighters%20in%20combat%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20Japanese%20comic%20art%20style%2C%20gritty%20atmosphere&width=800&height=600&seq=baki-carousel-03&orientation=landscape',
    tag: '经典战役',
  },
  {
    title: '相扑道 — 力与技',
    desc: '刃牙进入相扑世界，迎战拥有压倒性力量的力士们。力与技的碰撞，传统与现代格斗的交锋，刃牙将如何突破相扑的绝对力量？',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20illustration%20of%20a%20sumo%20wrestler%20versus%20a%20lean%20fighter%20in%20dynamic%20clash%2C%20traditional%20dohyo%20ring%2C%20warm%20earthy%20tones%2C%20Japanese%20comic%20art%20style%2C%20powerful%20impact%20moment&width=800&height=600&seq=baki-carousel-04&orientation=landscape',
    tag: '最新篇章',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          焦点专题
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10 max-w-lg mx-auto">
          精选刃牙漫画最受欢迎的四大篇章
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div key={item.imageUrl} className="group bg-background-50 border border-background-200/80 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all">
              <div className="flex flex-col sm:flex-row">
                <div className="flex-shrink-0 w-full sm:w-[200px] lg:w-[240px] h-[180px] sm:h-auto relative overflow-hidden bg-background-100">
                  <img
                    src={item.imageUrl}
                    alt={`刃牙漫画 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                  <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-md mb-2 self-start">
                    {item.tag}
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}